<div id="chartContainer" [hidden]="true"></div>
